import type {Size2D} from '@gongxigames/framework/core/types/Size2D';
import type {RUnit, ResponsivePointOptions} from './types';
import {calcResponsiveUnits} from './utils';
import {Point} from 'pixi.js';

export class RPoint {
    static from(options: ResponsivePointOptions): RPoint {
        return new RPoint(options.x, options.y);
    }

    constructor(
        public x: RUnit = '0',
        public y: RUnit = '0',
    ) {}

    calcToPixiPoint(context: Size2D, result: Point): void {
        result.x = calcResponsiveUnits(context.width, this.x);
        result.y = calcResponsiveUnits(context.height, this.y);
    }
}